"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.layerZeroChainIds = void 0;
const types_1 = require("../types");
exports.layerZeroChainIds = {
    [types_1.ChainId.POLYGON]: 109,
    [types_1.ChainId.FANTOM]: 112,
    [types_1.ChainId.ARBITRUM]: 110,
    [types_1.ChainId.AVALANCHE]: 106,
    [types_1.ChainId.BSC]: 102,
    [types_1.ChainId.MAINNET]: 101,
    [types_1.ChainId.OPTIMISM]: 111,
    [types_1.ChainId.CELO]: 125,
    [types_1.ChainId.GNOSIS]: 145,
    [types_1.ChainId.POLYGONZKEVM]: 158,
    [types_1.ChainId.BASE]: 184,
    [types_1.ChainId.LINEA]: 183,
    [types_1.ChainId.MANTLE]: 181,
    [types_1.ChainId.ZKSYNC]: 165,
    arbitrum: 110,
    'arbitrum-rinkeby': 10010,
    avalanche: 106,
    bsc: 102,
    'bsc-testnet': 10002,
    celo: 125,
    ethereum: 101,
    fantom: 112,
    'fantom-testnet': 10012,
    fuji: 10006,
    gnosis: 145,
    'gnosis-chain': 145,
    mumbai: 10009,
    optimism: 111,
    'optimism-kovan': 10011,
    polygon: 109,
    rinkeby: 10001,
    base: 184,
};
//# sourceMappingURL=layerZero.js.map